import { eEstadoSede } from "../common/enumModel";
import { IFilterSedeModel } from "../interfaces/sedes/IFilterSedeModel";

export class FilterSedeModel implements IFilterSedeModel {    
    idSede: number[];
    sede: string;
    idEstado: eEstadoSede;
    page: number;
    pageSize: number;
    companias: number[];
    
    constructor(){
        this.idSede = new Array<number>();
        this.sede = '';
        this.idEstado = eEstadoSede.ACTIVO;
        this.page = 1;
        this.pageSize = 30;
        this.companias = new Array<number>();
    }
}